var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.544,
    height: 149.999,
    viewBox: "0 0 130.544 149.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42152",
    "data-name": "Group 42152",
    transform: "translate(-105.994 -158.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19877",
    "data-name": "Path 19877",
    d: "M193.723,267.229c7.283-7.047,15.636-9.729,25.349-6.887a24.543,24.543,0,1,1-30.817,17.571c.663-2.488.1-3.54-1.96-4.791-12.328-7.5-24.571-15.149-36.845-22.743a6.3,6.3,0,0,0-.773-.311c-5.771,5.68-12.737,8.667-21.039,7.679a24,24,0,0,1-16.03-8.771,24.488,24.488,0,0,1,1.44-32.793c9.774-9.933,22.836-9.786,35.83.534,4.406-2.721,8.875-5.474,13.34-8.238,8.21-5.081,16.4-10.2,24.642-15.22,1.531-.932,2.083-1.673,1.545-3.65a24.442,24.442,0,1,1,7.562,11.927c-.728-.631-1.434-1.286-2.246-2.014q-10.04,6.207-19.955,12.339c-6.135,3.8-12.252,7.631-18.408,11.4-1.186.726-1.94,1.307-1.405,2.964a24.584,24.584,0,0,1,.069,14.415,2.676,2.676,0,0,0,.706,2.368C167.687,251.137,180.708,259.173,193.723,267.229ZM115,233.389a15.55,15.55,0,1,0,15.585-15.622A15.568,15.568,0,0,0,115,233.389Zm81.429-50.537a15.548,15.548,0,0,0,31.094.3,15.549,15.549,0,1,0-31.094-.3Zm0,101A15.548,15.548,0,1,0,212,268.251,15.586,15.586,0,0,0,196.433,283.851Z",
    transform: "translate(0 0)",
    fill: "#fffbf5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.dc078c9e5c68a8f996b42a7f0cb40bb7.svg";
export { ForwardRef as ReactComponent };